import React from "react";
import { Route, Redirect } from "react-router-dom";

import { useAuth } from "@hooks/use-auth";

const ProtectedRouter = ({ component: Component, ...rest }: any) => {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (user) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRouter;
